import { render, staticRenderFns } from "./FeedbackShare.vue?vue&type=template&id=08212202&"
import script from "./FeedbackShare.vue?vue&type=script&lang=ts&"
export * from "./FeedbackShare.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackShare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports